/**
 * Which build is actually running in this browser.
 *
 * Read the long note on `buildId()` in `vite.config.ts` for why this exists. The short version:
 * a service worker can pin a tab to an old bundle indefinitely, and when it does, "the fix did
 * not work" and "you are looking at last week's code" produce identical screenshots. Three
 * separate fixes were reported as shipped while his browser was running the build from before
 * them. Putting the identifier on screen makes those two cases one glance apart.
 *
 * `__BUILD_ID__` is replaced at build time by Vite's `define`. The fallback is for the test
 * environment, where no define runs, and it is deliberately a word rather than a plausible-looking
 * id: "dev" on a production screenshot is itself a useful signal.
 */
declare const __BUILD_ID__: string | undefined;

export const BUILD_ID: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';
